import React from "react";
import AppTheme from "../../../service/app_config/AppTheme";
import { IconNormal } from "../../../widget/common/ui/Icon";
import SessionStorage from "../../../service/storage/SessionStorage";
import StorageKeys from "../../../const/StorageKeys";

const ProductsActions = () => {
  const fileUrlSession: string =
    SessionStorage.getValue(StorageKeys.home_branch_product_url) || "";

  const urlArr: Array<string> = fileUrlSession.split("/");
  const fileName = urlArr[urlArr.length - 1];

  return (
    <>
      <a href={fileUrlSession} download={fileName} target="_blank"  rel="noopener noreferrer">
        <IconNormal name="download" color={AppTheme.themeFont} />
      </a>
    </>
  );
};

export default ProductsActions;
